<script>
    import icon from "@songfinch/customer/assets/images/calendar.png";
    export default {
        name: "EventReminderBlock",
        data() {
            return {
                icon
            };
        }
    };
</script>

<template>
    <div class="@bg-sfc-dark-beige @pt-10 @pb-14">
        <div class="@container @text-center">
            <img class="@ml-2 @inline-block @mb-4" :src="icon" alt="calendar">
            <h2 class="@max-w-700 @mx-auto @mb-2">
                Send yourself a reminder
            </h2>
            <div class="@text-sfc-dark-grey @max-w-475 @mx-auto @mb-5 p2">
                Let us know the date and we’ll send an email reminder a couple weeks before your event.
            </div>
            <router-link :to="{name: 'SetRemider'}" class="mkButton white short d-inline-flex align-items-center">
                Schedule now
            </router-link>
        </div>
    </div>
</template>
